import { render, staticRenderFns } from "./PathRenderer.vue?vue&type=template&id=db4b1536&"
import script from "./PathRenderer.vue?vue&type=script&lang=js&"
export * from "./PathRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports